import { CustomerBusinessType } from 'src/constants/customer/enums'

const notOtherBusinessTypes: string[] = [
  CustomerBusinessType.IcsProvide,
  CustomerBusinessType.Lease,
  CustomerBusinessType.Own,
]

export const getMCBusinessType = (initialBusinessType: string) => {
  const businessType = notOtherBusinessTypes.includes(initialBusinessType)
    ? initialBusinessType
    : CustomerBusinessType.Other

  const otherBusinessType = businessType === CustomerBusinessType.Other ? initialBusinessType : ''

  return {
    businessType,
    otherBusinessType,
  }
}
